import type { LegacyImportedCaseProjection } from "../types/legacyCases";

interface ReportPhotoState {
  isLegacyImported?: boolean;
  isFinalized?: boolean;
  signedOffAt?: string | null;
  isBlocked?: boolean;
  isReadOnly?: boolean;
  canCreateFromExternalBaseline: boolean;
  isAddendumEligibilityUnavailable: boolean;
  legacyProjection?: Pick<
    LegacyImportedCaseProjection,
    "approvedBaselineId" | "canIssueReportRevisions"
  >;
}

export function getReportPhotoEligibility(state: ReportPhotoState) {
  const approvedLegacyBaseline = Boolean(
    state.legacyProjection?.approvedBaselineId &&
      state.legacyProjection.canIssueReportRevisions === true
  );
  const hasSignedReportForAddendumSection = state.isLegacyImported
    ? approvedLegacyBaseline
    : Boolean(
        state.isFinalized ||
          (state.signedOffAt && state.canCreateFromExternalBaseline)
      );
  const canAddPhotos = Boolean(
    (!state.isLegacyImported || approvedLegacyBaseline) &&
      (!state.isReadOnly ||
        (hasSignedReportForAddendumSection &&
          !state.isBlocked &&
          !state.isAddendumEligibilityUnavailable))
  );
  return { hasSignedReportForAddendumSection, canAddPhotos };
}
